import React, { HTMLAttributes } from "react";
import clsx from "clsx";

import SuccessIcon from "@material-ui/icons/Check";
import FailIcon from "@material-ui/icons/Clear";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import TableCellWrapper from "components/VetExamsTable/TableCellWrapper";
import DateCell from "../DateCell/DateCell";

import useStyles from "./styles";

interface IProps extends HTMLAttributes<HTMLDivElement> {
  bold?: boolean;
  horse: racehorse360.IHorse;
}

const LastExamCell = (props: IProps) => {
  const { horse, bold = false } = props;

  const classes = useStyles();

  const examResultIcon =
    horse.lastExamResult ===
    racehorse360.HorseExamResult.HORSE_EXAM_RESULT_PASSED ? (
      <SuccessIcon className={clsx(classes.icon, classes.success)} />
    ) : (
      <FailIcon className={clsx(classes.icon, classes.fail)} />
    );

  return (
    <TableCellWrapper className={classes.lastExamCell} centered bold={bold}>
      {Boolean(horse.lastExamResult) && examResultIcon}
      <DateCell date={horse.lastExamDate} bold={bold} />
    </TableCellWrapper>
  );
};

export default React.memo(LastExamCell);
